export const Labels = {
  START: 0,
  WONDERFUL_WORLD: 1,
  PROBLEMATIC: 2,
  HARD: 3,
  MUSHY: 4,
  BRUISED: 5,
  PERFECT: 6,
  PERFECT_BUBBLE: 7,
  POST_SLIDE: 8,
  NERVOUS: 9,
  NO_FEAR: 10,
  NO_PRESERVATIVES: 11,
  NONE: 12,
  HPT_START: 13,
  HPT_1: 14,
  HPT_2: 15,
  HPT_3: 16,
  HPT_4: 17,
  // HPT_5: 18,
  HPT_5: 18,
  SUZIE: 19,
  BENNY_1: 20,
  BENNY_2: 21,
  SOURCE: 22,
  MARVELOUS: 23,
  AGAIN: 24,
  LTATU: 25
}

export const Breakpoints = [
  { label: Labels.START, time: 0 },
  { label: Labels.WONDERFUL_WORLD, time: 9 },
  { label: Labels.PROBLEMATIC, time: 15 },
  { label: Labels.HARD, time: 16 + 1 / 30 },
  { label: Labels.MUSHY, time: 16 + 23 / 30 },
  { label: Labels.BRUISED, time: 17 + 15 / 30 },
  { label: Labels.PERFECT, time: 18 + 7 / 30 },
  { label: Labels.PERFECT_BUBBLE, time: 18 + 23 / 30 },
  { label: Labels.POST_SLIDE, time: 18 + 26 / 30 },
  { label: Labels.NERVOUS, time: 19 + 13 / 30 },
  { label: Labels.NO_FEAR, time: 20 + 15 / 30 },
  { label: Labels.NO_PRESERVATIVES, time: 21 + 24 / 30 },
  { label: Labels.NONE, time: 23 + 9 / 30 },
  { label: Labels.HPT_START, time: 24 + 21 / 30 },
  { label: Labels.HPT_1, time: 25 + 8 / 30 },
  { label: Labels.HPT_2, time: 25 + 16 / 30 },
  { label: Labels.HPT_3, time: 25 + 24 / 30 },
  { label: Labels.HPT_4, time: 26 + 2 / 30 },
  // { label: Labels.HPT_5, time: 35 + 21 / 30 },
  { label: Labels.HPT_5, time: 36 + 0 / 30 },
  { label: Labels.SUZIE, time: 36 + 25 / 30 },
  { label: Labels.BENNY_1, time: 37 + 21 / 30 },
  { label: Labels.BENNY_2, time: 38 + 7 / 30, skip: true },
  { label: Labels.SOURCE, time: 39 + 12 / 30 },
  { label: Labels.MARVELOUS, time: 44 + 23 / 30 },
  { label: Labels.AGAIN, time: 46 + 0 / 30 },
  { label: Labels.LTATU, time: 46 + 1 / 30 }
]

export const Times = Breakpoints.reduce((a, v) => {
  a[v.label] = v.time * 30
  return a
}, {})

export const Sounds = [
  { key: 'outside-world', start: Times[Labels.START], end: Times[Labels.WONDERFUL_WORLD] - 20 },
  { key: 'outside-inside', start: Times[Labels.WONDERFUL_WORLD] - 10 },
  { key: 'smile-1', start: Times[Labels.WONDERFUL_WORLD] + 5 },
  { key: 'wonderful-world', start: Times[Labels.WONDERFUL_WORLD] + 5 },
  { key: 'smile-3', start: Times[Labels.NONE] - 10 },
  { key: 'tv-switch', start: Times[Labels.HPT_START] - 8 },
  { key: 'tv-switch', start: Times[Labels.HPT_1] - 3 },
  { key: 'tv-switch', start: Times[Labels.HPT_2] - 3 },
  { key: 'tv-switch', start: Times[Labels.HPT_3] - 3 },
  { key: 'tv-switch', start: Times[Labels.HPT_4] - 3 },
  { key: 'tv-switch', start: Times[Labels.HPT_4] + 2 },
  { key: 'underwater', start: Times[Labels.HPT_4] + 10, end: Times[Labels.HPT_5] - 4 },
  { key: 'tv-switch', start: Times[Labels.HPT_5] - 3 },
  { key: 'smile-4', start: Times[Labels.SUZIE] - 10 },
  { key: 'bacteria-buzzing', start: Times[Labels.BENNY_1] - 10, end: Times[Labels.SOURCE] + 3 },
  { key: 'smile-5', start: Times[Labels.BENNY_2] + 5 },
  { key: 'whoosh', start: Times[Labels.SOURCE] + 3 },
  { key: 'whoosh-2', start: Times[Labels.MARVELOUS] - 20 },
  // { key: 'whoosh', start: Times[Labels.AGAIN] - 20 },
]

Breakpoints.forEach((bp, i) => bp.index = i)

export const getBreakpoint = label => Breakpoints.find(bp => bp.label === label)

export const Sections = {
  intro: { time: Times[Labels.START] / 30, breakpoint: Labels.START, color: '#779A30' },
  avocados: { time: Times[Labels.PERFECT] / 30, breakpoint: Labels.PERFECT, color: '#BB7FB7' },
  pressure: { time: Times[Labels.POST_SLIDE] / 30, breakpoint: Labels.POST_SLIDE, color: '#E7E18D' },
  preservatives: { time: Times[Labels.NO_PRESERVATIVES] / 30, breakpoint: Labels.NO_PRESERVATIVES, color: '#B8DDD0' },
  hpt: { time: Times[Labels.HPT_START] / 30, breakpoint: Labels.HPT_START, color: '#DF8A97' },
  bacteria: { time: Times[Labels.BENNY_1] / 30, breakpoint: Labels.BENNY_1, color: '#EACEA4' },
  fresh: { time: Times[Labels.MARVELOUS] / 30, breakpoint: Labels.MARVELOUS, color: '#95C6E0' }
}